import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileCaptchaControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        let height = control.model.get("defaultHeight");
        element.css("height", height);

        let img = element[0].firstElementChild;
        img.style.width = "100%";
        img.style.height = height;
    }
}

const mobileCaptchaControlView = new MobileCaptchaControlView();
export default mobileCaptchaControlView;